// apps/admin-dashboard/src/app/global-error.tsx
'use client';

import { useEffect } from 'react';
import * as Sentry from '@sentry/nextjs';
import { recoverFromChunkError } from '@/lib/chunk-reload';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // This app has no route-level error.tsx, so every client error — including a
    // stale chunk after a deploy — propagates here. Recover before reporting so a
    // routine deploy does not read as an application fault.
    if (recoverFromChunkError(error)) return;
    console.error(error);
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang="id">
      <body style={{ margin: 0, fontFamily: 'system-ui, -apple-system, sans-serif' }}>
        <main
          style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '1.5rem',
            background: '#f7fafa',
          }}
        >
          <div style={{ maxWidth: '28rem', textAlign: 'center' }}>
            <h1 style={{ fontSize: '1.5rem', fontWeight: 700, color: '#0f172a', margin: 0 }}>
              Terjadi kesalahan
            </h1>
            <p style={{ marginTop: '0.75rem', color: '#475569' }}>
              Maaf, aplikasi mengalami kendala. Silakan muat ulang halaman.
            </p>
            <button
              onClick={reset}
              style={{
                marginTop: '1.5rem',
                background: '#0d9488',
                color: '#fff',
                border: 0,
                borderRadius: '0.5rem',
                padding: '0.625rem 1.25rem',
                fontWeight: 600,
                fontSize: '0.875rem',
                cursor: 'pointer',
              }}
            >
              Muat ulang
            </button>
          </div>
        </main>
      </body>
    </html>
  );
}
